import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { catViewSelector, defaultTagSelector, subTagsListSelector } from './store/selectors';

class DescriptionCellRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    defaultTagOptions: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }).isRequired
    ),
    catViewOptions: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }).isRequired
    ),
    subTagsOptions: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      })
    ),
  };

  render() {
    const { value, catViewOptions, defaultTagOptions, subTagsOptions } = this.props;
    if (!value) {
      return null;
    }

    const descriptions = catViewOptions.concat(defaultTagOptions).concat(subTagsOptions);

    const renderedValue = descriptions.find(option => option.value === value);

    if (!renderedValue) {
      return null;
    }

    return (
      <span>
        { renderedValue.label }
      </span>
    );
  }
}

const mapStateToProps = state => ({
  catViewOptions: catViewSelector(state),
  defaultTagOptions: defaultTagSelector(state),
  subTagsOptions: subTagsListSelector(state),
});

export default connect(mapStateToProps, null)(DescriptionCellRenderer);
